import {pluralNumber} from '../../../utils/numerals/pluralNumber';
import {spaceNumber} from '../../../utils/numerals/spaceNumber';

export const renderHeading = ( chooserData ) => `${chooserData.rooms_total !== 1 ? 'Найдено' : 'Найден'} <strong>${pluralNumber( chooserData.rooms_total, 'вариант', 'варианта', 'вариантов' )}</strong>`;

export const renderApartmentsList = ( chooserData ) => {
	let renderedList = '';

	chooserData.roomsData.rooms.forEach( ( it ) => {
		renderedList += `<li>
				<a${it.enums.state && it.enums.state.value === 'state_booked' ? ' class="booked"' : ''} href="/apartments/${it.id}/">
					<ul>
						<li class="area">
							<strong>${it.layout.areas.main.value.toFixed( 2 ).replace( '.', ',' )}&nbsp;м², ${it.layout.properties.rooms_count.value}&nbsp;к</strong>
						</li>
						<li class="number">№&#8202;${it.id.split( '-' )[0]}</li>
						<li class="building">${it.level.split( '/' )[0]}&nbsp;дом</li>
						<li class="floor">${it.properties.floor.value}&nbsp;этаж</li>
						<li class="price">
							<strong>${ it.prices.full.value ? `${spaceNumber( it.prices.full.value )}&nbsp;₽` : 'По запросу' }</strong>
						</li>
					</ul>
					<div class="choose" aria-label="Перейти к квартире">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12">
							<path fill="#da950b" fill-rule="evenodd" clip-rule="evenodd" d="M10.88.425a.5.5 0 0 1 .705.054l4.453 5.196a.5.5 0 0 1 0 .65l-4.453 5.196a.5.5 0 0 1-.705.054l-.76-.65a.5.5 0 0 1-.054-.705L12.826 7H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 5h12.326l-2.76-3.22a.5.5 0 0 1 .054-.705l.76-.65Z" />
						</svg>
					</div>
				</a>
			</li>`;
	} );

	return renderedList;
};
